export interface ICheatUISection {
  destroy(): void;
}

export class CheatUISection implements ICheatUISection {
  public contentEl: HTMLDivElement = document.createElement('div');

  constructor() {}

  protected initializeBaseUI(consoleEl: HTMLDivElement): void {
    Object.assign(this.contentEl.style, {});

    consoleEl.appendChild(this.contentEl);
  }

  public getChildEl<T extends HTMLElement>(selector: string): T | null {
    return this.contentEl.querySelector(selector) || null;
  }

  public getAllChildEl<T extends HTMLElement>(selector: string): T[] {
    return Array.from(this.contentEl.querySelectorAll(selector));
  }

  public destroy(): void {
    this.contentEl.innerHTML = '';
    this.contentEl.parentElement?.removeChild(this.contentEl);
  }
}
